import { S_BILLING_INFO, S_CONTACT_INFO, S_DELIVERY, S_DIFF_ADDR, S_MEMBER_TYPE, S_SHIPPING_INFO, webStorage, S_USER, S_PICKUP_STORE } from "../../utils/webStorage";
import { restoreData } from "../restoreData";
import { SET_BILLING_INFO, SET_CONTACT_INFO, SET_DELIVERY, SET_DIFF_ADDR, SET_GUEST_INFO, SET_SHIPPING_INFO, CLEAR_SHIPPING_INFO, CLEAR_BILLING_INFO, CLEAR_CONTACT_INFO, SET_DISABLED_SKUIDS, SET_PICKUP_STORE, GEAR_CLEAR_CHECKOUT } from "../actions/gears-checkout";
import _ from "lodash";
import { isBizNull } from "../../utils";
const memberType = restoreData(S_MEMBER_TYPE, {});
const delivery = restoreData(S_DELIVERY, {});
const pickupStore = restoreData(S_PICKUP_STORE, null);
const billingInfo = restoreData(S_BILLING_INFO);
const shippingInfo = restoreData(S_SHIPPING_INFO);
const contactInfo = restoreData(S_CONTACT_INFO, {});
const diffAddr = restoreData(S_DIFF_ADDR, false);
export const gearCheckoutStates = {
  memberType,
  delivery,
  billingInfo,
  shippingInfo,
  contactInfo,
  diffAddr,
  pickupStore
};
export const gearCheckoutReducer = (state, action) => {
  const { type, ...data } = action;
  switch (type) {
    case SET_GUEST_INFO:
      const guest = _.merge(state.guest, data);
      return {
        ...state,
        guest
      };
    case SET_DELIVERY:
      const delivery = {
        ...data
      };
      webStorage.set(S_DELIVERY, delivery);
      return {
        ...state,
        delivery
      };
    case SET_SHIPPING_INFO:
      const shippingInfo = data.payload;
      webStorage.set(S_SHIPPING_INFO, shippingInfo);
      return {
        ...state,
        shippingInfo
      };
    case CLEAR_SHIPPING_INFO: {
      webStorage.clear(S_SHIPPING_INFO);
      return {
        ...state,
        shippingInfo: null
      };
    }
    case SET_BILLING_INFO:
      webStorage.set(S_BILLING_INFO, data.payload);
      return {
        ...state,
        billingInfo: data.payload
      };
    case CLEAR_BILLING_INFO: {
      webStorage.clear(S_BILLING_INFO);
      return {
        ...state,
        billingInfo: null
      };
    }
    case SET_CONTACT_INFO:
      webStorage.set(S_CONTACT_INFO, data.payload);
      return {
        ...state,
        contactInfo: data.payload
      };
    case CLEAR_CONTACT_INFO: {
      webStorage.clear(S_CONTACT_INFO);
      return {
        ...state,
        contactInfo: null
      };
    }
    case SET_DIFF_ADDR:
      if (data.payload === null) {
        webStorage.clear(S_DIFF_ADDR);
      } else {
        webStorage.set(S_DIFF_ADDR, data.payload);
      }
      return {
        ...state,
        diffAddr: data.payload
      };
    case GEAR_CLEAR_CHECKOUT: {
      webStorage.clear(S_BILLING_INFO);
      webStorage.clear(S_SHIPPING_INFO);
      webStorage.clear(S_CONTACT_INFO);
      webStorage.clear(S_DIFF_ADDR);
      return {
        ...state,
        billingInfo: null,
        shippingInfo: null,
        contactInfo: null,
        diffAddr: null
      };
    }
    case SET_DISABLED_SKUIDS:
      return {
        ...state,
        disabledSkuIds: data.skuIds
      };
    case SET_PICKUP_STORE:
      if (isBizNull(data.payload)) {
        webStorage.clear(S_PICKUP_STORE);
      } else {
        webStorage.set(S_PICKUP_STORE, data.payload);
      }
      return {
        ...state,
        pickupStore: data.payload
      };
    default:
      return state;
  }
};
